import { Injectable } from "@angular/core";

@Injectable()
export class TAAConstants {
  getPENDING() {
    return "Pending";
  }
  getINCOMPLETE() {
    return "Incomplete";
  }
  getACTION_REQUIRED() {
    return "Action Required";
  }
  getCOMPLETE() {
    return "Complete";
  }
  getDELETED() {
    return "Deleted";
  }
  getASSIGNED() {
    return "Assigned";
  }
  getINREVIEW() {
    return "InReview";
  }
  getDISPLAY_CODE_INREVIEW() {
    return "In review";
  }
  getRECONSIDER() {
    return "Reconsider";
  }
  getRECONSIDER_INCOMPLETE() {
    return "ReconsiderIncomplete";
  }
  getAPPROVED() {
    return "Approved";
  }
  getNOT_APPROVED() {
    return "NotApproved";
  }
  getNOT_APPROVED_DISPLAY_CD() {
    return "Not Approved";
  }
  getPARTIALLY_APPROVED() {
    return "PartiallyApproved";
  }
  getPARTIALLY_APPROVED_DISPLAY_CD() {
    return "Partially Approved";
  }
  getEXTERNALLY_REVIEWED() {
    return "ExternallyReviewed";
  }
  getAP() {
    return "AP";
  }
  getSYSTEM_APPROVED() {
    return "SystemApproved";
  }
  getINACTIVE() {
    return "I";
  }
  getACTIVE() {
    return "A";
  }
  getREQUEST_TYPE_CODE_ONLINE() {
    return "Online";
  }
  getREQUEST_TYPE_CODE_PAPER() {
    return "Paper";
  }
  getYES_FLAG() {
    return "Y";
  }
  getNO_FLAG() {
    return "N";
  }
  getNONE() {
    return "None";
  }
  getEMPTY_STRING() {
    return "";
  }
  getSPACE() {
    return " ";
  }
  getCOMMA() {
    return ",";
  }
  getOPEN_BRACKECT() {
    return "(";
  }
  getCLOSE_BRACKET() {
    return ")";
  }
  getEXTERNAL() {
    return "external";
  }
  getINTERNAL() {
    return "internal";
  }
  getREQUEST_ASSIGNED() {
    return "RequestAssigned";
  }
  getREQUEST_UNASSIGNED() {
    return "RequestUnassigned";
  }
  getREQUEST_COMPLETE() {
    return "RequestComplete";
  }
  getREQUEST_AUTO_APPROVED() {
    return "RequestAutoApproved";
  }
  getMY_REQUEST() {
    return "MyRequest";
  }
  getTAC_REQUEST() {
    return "TacRequest";
  }
  getREQUEST_NO_DATA() {
    return "NO_DATA";
  }
  getREQUEST_CONSULTANT_DATA() {
    return "CONSULTANT_DATA";
  }
  getREQUEST_SUPPORT_SEARCH() {
    return "SUPPORT_SEARCH";
  }
  getREQUEST_ID() {
    return "rId";
  }
  getPERSON_ID() {
    return "pId";
  }
  getISLOCKEDFL() {
    return "lFl";
  }
  getDECISION_FL_YES() {
    return "1";
  }
  getDECISION_FL_NO() {
    return "0";
  }
  getSTATUS_FL_ACTIVE() {
    return "A";
  }
  getSTATUS_FL_INACTIVE() {
    return "I";
  }
  getEXCEPTION_STATEMENT() {
    return "Exceptions Statement";
  }
  getELL_PLAN() {
    return "ELLPLAN";
  }
  getYEARS_ON_PLAN_LESS_THAN_ONE() {
    return "<1";
  }
  getYEARS_ON_PLAN_GREATER_THAN_OR_EQUAL_ONE() {
    return "=>1";
  }
  getDECISION_TABLE_YOP_LESS_THAN_ONE() {
    return "L";
  }
  getDECISION_TABLE_YOP_GREATER_THAN_ONE() {
    return "G";
  }
  getMONTHS_ON_PLAN_LESS_THAN_FOUR() {
    return "<4";
  }
  getMONTHS_ON_PLAN_GREATER_THAN_OR_EQUAL_FOUR() {
    return "=>4";
  }
  getDECISION_TABLE_MOP_LESS_THAN_FOUR() {
    return "N";
  }
  getDECISION_TABLE_MOP_GREATER_THAN_FOUR() {
    return "M";
  }
  getDECISION_TABLE_YOP_NOT_AVAILABLE() {
    return "NA";
  }
  getOTHER() {
    return "OTHER";
  }
  getPRESENTATION_ACCOMM_P2() {
    return "P2";
  }
  getPRESENTATION_ACCOMM_P4() {
    return "P4";
  }
  getPRESENTATION_ACCOMM_P5() {
    return "P5";
  }
  getPRESENTATION_ACCOMM_P16() {
    return "P16";
  }
  getNAVIGATION_ACCOMM_N5() {
    return "N5";
  }
  getTIMING_ACCOMM_T3() {
    return "T3";
  }
  getTIMING_ACCOMM() {
    return "Timing";
  }
  getLOCATION_ACCOMM() {
    return "Setting & Location";
  }
  getNAV_ACCOMM() {
    return "Response & Navigation";
  }
  getFORMAT_ACCOMM() {
    return "Presentation & Formats";
  }
  getREQUEST_CHECK() {
    return "Request Not Found";
  }
  getQUESTION_CONFIRMATION_PREVIOUS() {
    return "All the changes would be lost if you do not save your work. Do you want to continue? ";
  }
  getNAVIGATIONAL_STATES() {
    return "navigational_states";
  }
  getEXCEPTIONS_STATEMENT() {
    return "Exceptions Statement";
  }
  getPLAN_RADIO_VALUE() {
    return "planRadioValue";
  }
  getCOLON_SEPARATED_NAVIGATIONAL_STATES() {
    return "EXAMINEE_DETAILS:TESTING_INFORMATION:DIAGNOSED_DISABILITIES:PLAN_DETAILS:ACCOMODATIONS:DOCUMENTATION:REVIEW:CONFIRMATION";
  }
  getCOLON() {
    return ":";
  }
  getTEST_NAME_RADIO_VALUE() {
    return "testNameRadioValue";
  }
  getUSER_FROM_TOKEN_RETRIEVE_SUCCESS_CODE() {
    return "200";
  }
  getPDF_MIME_TYPE() {
    return "application/pdf";
  }
  getCONSULTANT_ID() {
    return "consultantId";
  }
  getREVIEW_DETAIL_ID() {
    return "reviewDetailId";
  }
  getREVIEW_STATUS() {
    return "reviewStatus";
  }
  getREQUEST_CREATED() {
    return "REQUESTOR";
  }
  getREQUEST_REVIEWER() {
    return "REVIEWER";
  }
  getMMDDYYYY() {
    return "MM/dd/yyyy";
  }
  getMMDDYYYY_HHMMSSAA() {
    return "MM/dd/yyyy h:mm:ss aa";
  }
  getYYYYMMDD_HHMMSSSSS() {
    return "yyyy-MM-dd HH:mm:ss.SSS";
  }
  getMMDDYYYY_HH24MMSS() {
    return "MM/dd/yyyy HH:mm:ss";
  }
  getONE_OR_MORE_YEAR() {
    return "1 or more years";
  }
  getLESS_THEN_ONE_YEAR() {
    return "Less than 1 year";
  }
  getLOCKED_DEFAULT() {
    return "0";
  }
  getOTHER_NAME() {
    return "O";
  }
  getELL_VERBAL() {
    return "ELL_VERBAL_INST";
  }
  getNUMBER_OF_DAYS() {
    return "365";
  }
  getSEARCH_PAGE() {
    return "searchPage";
  }
  getTAA_LANDING_PAGE_SIZE() {
    return "10";
  }
  getRECONSIDER_ALERT_MSG_KEY() {
    return "REQUEST_STATUS_UPDATED_TO_RECONSIDER_MSG";
  }
  getRECONSIDER_DEFAULT_ALERT_MSG() {
    return "We will reconsider your request. Would you like to continue ?";
  }
  getREVIEW_STEP_ONE() {
    return "1";
  }
  getNAVIGATING_AWAY_MESSAGE() {
    return "Are you sure you want to navigate away from the current Screen? Any unsaved changes will be lost.";
  }
  getDEFAULT_TIMING_ACCOMM_MSG_KEY() {
    return "ON_DEFAULT_TIMING_ACCOMMODATION_CHANGED";
  }
  getSYSTEM_CONSULTANT() {
    return "SYSTEM";
  }
  getEXAMINEE_MIN_YEARS_DOB() {
    return "-5";
  }
  getYEARS_ON_PLAN() {
    return "YEARS_ON_PLAN";
  }
  getMONTHS_ON_PLAN() {
    return "MONTHS_ON_PLAN";
  }
  getERROR_PAGE_MSG() {
    return "errorPageMsg";
  }
  getTEST_TYPE_SPECIAL() {
    return "Special";
  }
  getTEST_TYPE_NATIONIAL() {
    return "National";
  }
  getTEST_TYPE_STATE() {
    return "State";
  }
  getCERTIFICATE_NEEDED() {
    return "Certification Needed";
  }
  getCERTIFICATE_COMPLETED() {
    return "Certification Complete";
  }
  getHSCODE_WS_SUCCESS_CODE() {
    return "200";
  }
  getINACTIVE_FLAG() {
    return "Inactive";
  }
  getACTIVE_FLAG() {
    return "Active";
  }
  getZERO() {
    return "0";
  }
  getPAPER_REQUEST() {
    return "Paper";
  }
  getERROR_MESSAGE() {
    return "error(s) on the page. Please correct and save.";
  }
  getPOPUP_HEIGHT() {
    return 150;
  }
  getPOPUP_WIDTH() {
    return 450;
  }
  getASSET_FARM_ONLINE_REQUEST_UPLOADED_DOCUMENTS_TYPE() {
    return "ONLINE_REQUEST";
  }
  getASSET_FARM_PAPER_REQUEST_UPLOADED_DOCUMENTS_TYPE() {
    return "PAPER_REQUEST";
  }
  getASSET_FARM_EXTERNAL_REVIEWER_UPLOADED_DOCUMENT_TYPE() {
    return "EXTERNAL_REVIEW";
  }
  getASSET_FARM_DECISION_NOTIFICATION_UPLOAD_DOCUMENT_TYPE() {
    return "DECISION_DOCUMENT";
  }
  getASSET_FARM_DECISION_NOTIFICATION_DOCUMENT() {
    return "DecisionNotificationDocument";
  }
  getINTERNAL_ERROR_MSG_DEFAULT() {
    return "System is experiencing problems. Please try again later.";
  }
  getINTERNAL_ERROR() {
    return "INTERNAL_ERROR_HEADER";
  }
  getROLE_IDMTAC() {
    return "IDMTAC";
  }
  getROLE_EXTERNAL_CONSULTANT() {
    return "ACCEXTCONS";
  }
  getROLE_INDIVIDUAL() {
    return "INDIVIDUAL";
  }
  getRECORDS_FOUND_MSG() {
    return " results.";
  }
  getREQUEST_COULD_NOT_DELETE_MESSAGE() {
    return "The request could not be deleted. Please try again later.";
  }
  getDOCUMENT_COULD_NOT_DELETE_MESSAGE() {
    return "Could not delete the document. Please try again later.";
  }
  getCONTACT_PHONE() {
    return "CONTACT_US_PHONE";
  }
  getCONTACT_INFO() {
    return "CONTACT_US_INFO";
  }
  getCONTACT_EMAIL() {
    return "CONTACT_US_EMAIL_ID";
  }
  getNAME_RegEx() {
    return /(^$|^[\/a-zA-Z0-9\ \-\/\(\)\_\.\,\=\/]{1,50}$)/;
  }
  getEmptySpaceRegEx() {
    return new RegExp(/^(?!\s*$).+/);
  }
  getAnalystEmailRegEx() {
    return /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-zA-Z]{2,6}(?:\.[a-zA-Z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/;
  }
}



// WEBPACK FOOTER //
// ./client/views/constants/taa-constants.ts